// enums
import { UserTitleType, UserTitleTypeKey, YnType } from 'enums';

// models
import type { UserInfo, BloodType, PackageType } from '../models/auth.model';

// libraries
import { atom } from 'recoil';

const initialState = {
  // 회원가입 폼
  SignUpForm: {
    user: {
      firstName: '',
      lastName: '',
      title: UserTitleType.MR.name as UserTitleTypeKey,
      password: '',
      ctg: 'PKG#1' as PackageType,
      mobile: '',
      preferLang: 'ENG',
      nationId: '',
      mobileNationId: '45b2cfec-1049-4ec0-9a53-8c6ac4f67550'
    },
    userDetail: {
      birthDate: '',
      email: '',
      companyId: '',
      designationId: '',
      disciplineId: '',
      occupationId: '',
      religionId: '',
      bloodType: '' as BloodType,
      iqamaNo: '',
      iqamaExpiryDate: '',
      passportNo: '',
      passportExpiryDate: '',
      gatepassNo: '',
      gatepassExpiryDate: '',
      agreement: YnType.N,
      status: ''
    }
  }
};

/** 회원가입 폼 */
export const SignUpFormAtom = atom<UserInfo>({
  key: 'SignUpFormAtom',
  default: initialState.SignUpForm
});

/** 패스워드 확인 */
export const PasswordCheckAtom = atom<string>({
  key: 'PasswordCheckAtom',
  default: ''
});
